import React from 'react';
import { Section } from './ui/Section';
export function Bonuses() {
  const bonuses = [{
    icon: '🔥',
    title: 'Planificador Express',
    desc: 'Planifica en 10 min'
  }, {
    icon: '✅',
    title: 'Checklist Pre-Clase Pro',
    desc: 'Entra listo siempre'
  }, {
    icon: '🗣️',
    title: 'Pack de Frases Pro',
    desc: '80+ correcciones reales'
  }];
  return <Section variant="alt" data-id="element-68">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title" data-id="element-69">
        🎁 Bonos Incluidos GRATIS
      </h2>

      <div className="grid md:grid-cols-3 gap-6" data-id="element-70">
        {bonuses.map((bonus, i) => <div key={i} className="bg-gradient-card border border-brand-borderGlow/20 rounded-2xl p-6 text-center shadow-violet-glow hover:shadow-gold-glow transition-all hover:border-brand-gold/30" data-id="element-71">
            <div className="text-4xl mb-4" data-id="element-72">{bonus.icon}</div>
            <h3 className="font-heading text-lg font-bold text-brand-subtitle mb-2 tracking-wide" data-id="element-73">
              {bonus.title}
            </h3>
            <p className="font-body text-brand-text" data-id="element-74">{bonus.desc}</p>
          </div>)}
      </div>
    </Section>;
}